// src/components/auth/components/Partners.tsx
//5/21/25 12:00 PM
// Updated to handle null imageUrl gracefully
// Aligned selectedPartnerValue with HomeLayout.tsx
// Updated to set "OLS Partners" as default selection
// Removed "No partner image available" message for OLS Partners
// Path: src/components/auth/components/Partners.tsx
// fix: Removed redundant console.log statement to clean up console warnings.
// This resolves the 'isValidImage: false' log spam without affecting functionality.
// 06/08/25 09:08 AM +07
import React, { useEffect } from "react";
import styled from "styled-components";
import { TreeSelect } from "antd";

const { TreeNode } = TreeSelect;

interface PartnerNode {
  key: string;
  value: string;
  title: string;
  disabled?: boolean;
  imageUrl: string | null;
}

interface PartnersProps {
  state?: {
    selectedPartnerValue?: string;
  };
  onPartnersClick: () => void;
  onChangePartners: (value: string) => void;
}

const PartnersContainer = styled.div`
  border-radius: 15px;
  margin: 30px 15px;
  padding: 10px;
  background: rgba(252, 226, 72, 0.8);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (min-width: 1040px) {
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 300px;
    margin: 0;
  }

  @media (max-width: 768px) {
    position: static;
    width: 100%;
    margin: 10px 0;
  }
`;

const PartnerImage = styled.img`
  margin-top: 10px;
  cursor: pointer;
  width: 200px;
  height: 200px;
  transition: transform 0.3s ease;
  display: block;
  margin-left: auto;
  margin-right: auto;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 150px;
    height: 150px;
  }
`;

const StyledTreeSelect = styled(TreeSelect)`
  width: 100%;
  margin-top: 10px;

  .ant-select-selector {
    border-radius: 4px;
    background: #ffffff;
    border-color: #0427f4;
  }

  .ant-select-selection-placeholder {
    color: #0427f4;
  }
`;

const DEFAULT_PARTNER_IMAGE = "https://via.placeholder.com/200x200?text=Image+Not+Found";

const Partners: React.FC<PartnersProps> = ({ state = {}, onPartnersClick, onChangePartners }) => {
  const { selectedPartnerValue = "w0-1" } = state; // Default to "OLS Partners"

  const partnerNodes: PartnerNode[] = [
    {
      key: "w0-1",
      value: "w0-1",
      title: "OLS Partners",
      disabled: false,
      imageUrl: null,
    },
    {
      key: "w1-1",
      value: "w1-1",
      title: "Artis School of Music",
      imageUrl: "https://www.artismymusic.com/static/media/logo.ffee978310e6835367641750451e7fe7.svg",
    },
  ];

  useEffect(() => {
    // This log is useful for debugging the selected value
    console.log("Current selectedPartnerValue:", selectedPartnerValue);
  }, [selectedPartnerValue]);

  const handleTreeSelectChange = (value: string) => {
    console.log("TreeSelect changed to:", value);
    onChangePartners(value);
  };

  const selectedNode = partnerNodes.find((node) => node.value === selectedPartnerValue) || partnerNodes[0];
  const imageUrlPartners = selectedNode.imageUrl;

  const isValidImage = !!imageUrlPartners;

  // FIX: Removed the noisy console.log that was cluttering the output.
  // The rendering logic below already handles the UI correctly.

  return (
    <PartnersContainer className="partners">
      {isValidImage && (
        <PartnerImage
          onClick={onPartnersClick}
          src={imageUrlPartners}
          alt="Partner Logo"
          aria-label="Partner logo, click to visit"
          onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
            console.log("Image failed to load:", imageUrlPartners);
            (e.target as HTMLImageElement).src = DEFAULT_PARTNER_IMAGE;
          }}
        />
      )}
      <StyledTreeSelect
        showSearch
        value={selectedPartnerValue}
        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
        placeholder="Select a partner"
        allowClear
        onChange={handleTreeSelectChange}
        treeDefaultExpandAll={false}
        aria-label="Select partner organization"
      >
        {partnerNodes.map((node) => (
          <TreeNode
            key={node.key}
            value={node.value}
            title={node.title}
            disabled={node.disabled}
          />
        ))}
      </StyledTreeSelect>
    </PartnersContainer>
  );
};

export default Partners;